<template>
  <section>
    <KpiCards
      class="mb-3"
      :items="kpiItems"
      :loading="loadingSummary"
      :skeleton="5"
    >
      <template #extra="{ item }">
        <div v-if="item.currency_breakdown" class="ps-kpi-currency ml-auto">
          <CurrencyBreakdown :breakdown="item.currency_breakdown" />
        </div>
      </template>
    </KpiCards>

    <data-table
      :headers="headers"
      :items="allProducts"
      commit="SET_ALL_PRODUCTS"
      :viewItem="viewItem"
    >
      <div slot="activator" class="row justify-content-between mb-4">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-2">
          <v-card-title class="px-0 pt-0 ps-products-title">
            {{ $t("product") }}
          </v-card-title>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3 offset-lg-3">
          <TextSearch
            v-model="search"
            @search="fetchItem()"
            @onClear="
              search = '';
              fetchItem();
            "
          />
        </div>
        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-2">
          <TextSelect
            :dense="true"
            :placeholder="false"
            :items="categoryOptions"
            v-model="category_id"
            :returnObject="false"
            text="text"
            itemValue="value"
            @input="fetchItem()"
          />
        </div>
        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-2">
          <TextSelect
            :dense="true"
            :placeholder="false"
            :items="statusOptions"
            v-model="status"
            :returnObject="false"
            :searchable="false"
            text="text"
            itemValue="value"
            @input="fetchItem()"
          />
        </div>
      </div>
    </data-table>

    <app-custom-dialog v-model="dialog" :footer="false" title="description">
      <div slot="activator">
        <AppDetail :item="form" />
      </div>
    </app-custom-dialog>
    <app-loading :overlay="overlay" />
  </section>
</template>

<script>
import DataTable from "@/components/DataTable";
import { mapGetters, mapActions } from "vuex";
import { productHead } from "@/utils/head";
import AppDetail from "@/components/products/details";
import CurrencyBreakdown from "@/components/global/CurrencyBreakdown.vue";
import { myMixin } from "@/mixin/main";
import { adminStoreSummary } from "@/mixin/adminStoreSummary";

export default {
  mixins: [myMixin, adminStoreSummary],
  components: { DataTable, AppDetail, CurrencyBreakdown },
  data: () => ({
    overlay: false,
    search: "",
    dialog: false,
    form: {},
    categories: [],
    category_id: 0,
    status: "",
  }),
  async created() {
    await Promise.all([
      this.fetchItem(),
      this.fetchSummary("products"),
      this.fetchCategories(),
    ]);
  },
  computed: {
    ...mapGetters({
      allProducts: "index/allProducts",
    }),
    headers() {
      // the owner columns, with a read-only status chip instead of the editable switch
      return productHead(this).map((h) =>
        h.value === "is_active" ? { ...h, value: "statusUser" } : h,
      );
    },
    categoryOptions() {
      const lang = this.$i18n.locale;
      const key = lang === "en" ? "en_name" : lang === "th" ? "th_name" : lang === "cn" || lang === "ch" ? "cn_name" : "la_name";
      return [
        { value: 0, text: `${this.$t("category")}: ${this.$t("all")}` },
        ...this.categories.map((c) => ({
          value: c.id,
          text: c[key] || c.la_name || c.en_name || String(c.id),
        })),
      ];
    },
    statusOptions() {
      return [
        { value: "", text: `${this.$t("status")}: ${this.$t("all")}` },
        { value: 1, text: this.$t("active") },
        { value: 0, text: this.$t("inactive") },
      ];
    },
  },
  methods: {
    ...mapActions({
      fetch: "index/fetch",
    }),
    // the 3rd card (inventory cost) carries the per-currency breakdown, as on the owner page
    kpiExtra(item, index) {
      return index === 2 ? { currency_breakdown: item.currency_breakdown } : {};
    },
    async fetchCategories() {
      const { store_id } = this.$route.params;
      try {
        const { data } = await this.$http.get(
          `get_shop_categories/${store_id}?per_page=1000`,
        );
        const d = data.data;
        this.categories = Array.isArray(d) ? d : (d && d.data) || [];
      } catch (error) {
        console.error(error);
      }
    },
    async fetchItem() {
      const { store_id } = this.$route.params;
      const params = [`q=${encodeURIComponent(this.search || "")}`];
      if (this.category_id) params.push(`cat_id=${this.category_id}`);
      if (this.status !== "" && this.status !== null) params.push(`is_active=${this.status}`);
      const body = {
        that: this,
        url: `get_shop_products/${store_id}?${params.join("&")}`,
        commit: "SET_ALL_PRODUCTS",
      };
      await this.fetch(body);
    },
    viewItem(item) {
      this.form = item;
      this.dialog = !this.dialog;
    },
  },
};
</script>

<style scoped>
.ps-products-title {
  font-size: 1.25rem;
  font-weight: 900;
  color: #141021;
}
</style>
